// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3ZXAo9HVcR5rAnJd8SjdBm","icon":"_1vvlV7aDDpALGSJ0flztZq"};